module.exports = __webpack_public_path__ + "static/media/latinad-main-mobile.547a4c65.png";